<script setup lang="ts">
import { useRouter } from 'vue-router';
import useCompanyImageBaseUrl from '@Use/useCompanyImageBaseUrl';
import { useCompanyStore } from '@Stores/company.store';
import { useLocationStore } from '@Stores/location.store';
import { GuidedShowcaseLayout } from '@Shared';
import IdBlurryWarning from '@Assets/images/idv/id-blurry-warning.svg';
import ShowcaseImage from '@Components/shared/ShowcaseImage.vue';


const router = useRouter();
const companyStore = useCompanyStore();
const locationStore = useLocationStore();
const companyImageBaseUrl = useCompanyImageBaseUrl();
const redoVerification = () => {
    router.push({ name: 'match-idv-select-doc-type' });
};
</script>

<template>
    <guided-showcase-layout
        suppress-back-to-dashboard
        :company="companyStore.company"
        :brand="companyStore.brand"
        :location="locationStore.location"
        :company-image-base-url="companyImageBaseUrl">
        <div class="match-retry-view">
            <app-form-content-layout>
                <app-image :src="IdBlurryWarning" data-id="match-retry-image" />
                <h1 class="match-retry-view__headline" data-id="match-retry-title">
                    We couldn't read the details on your ID
                </h1>
                <div class="match-retry-view__inner-text-container">
                    <p data-id="match-retry-description">
                        To avoid any delays, please redo the verification, making sure that:
                    </p>
                    <ul class="match-retry-view__list" data-id="match-retry-list">
                        <li>
                            The photo is clear, and not blurry
                        </li>
                        <li>
                            The details on your ID are easy to read
                        </li>
                        <li>
                            The photo is free of any glare
                        </li>
                        <li>
                            The entire ID is visible in the photo, and no details are cut off
                        </li>
                    </ul>
                </div>
                <app-button
                    expanded
                    size="large"
                    type="primary"
                    data-id="match-retry-redo-button"
                    @onClick="redoVerification">
                    Redo Verification
                </app-button>
            </app-form-content-layout>

        </div>
        <template #branded>
            <showcase-image />
        </template>
    </guided-showcase-layout>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;
.match-retry-view {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;

    &__headline {
        margin-bottom: 1rem;
    }

    &__inner-text-container {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
    }

    &__list {
        display: flex;
        flex-direction: column;
        gap: .5rem;
        padding-inline-start: 1rem;
        list-style-position: outside;
        margin-block-start: 0;
        margin-block-end: 0;
    }


}
</style>
